import styled from 'styled-components';
import DefaultButton from 'components/Buttons/Button';
import { Box as DefaultBox } from '@material-ui/core';
import { NavLink as NavLinkDefault } from 'react-router-dom';
import { FiMessageCircle } from 'react-icons/fi';
import DefaultGlobalLoader from 'components/Loaders/GlobalLoader';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  min-height: 100vh;
`;

// TODO: TFR-44 move to container group
export const Content = styled.div`
  flex: 1;
  margin: 0 auto;
  padding: 0 3rem;
  max-width: 80rem;
`;

// TODO: TFR-44 move to button group
export const ChatButton = styled(DefaultButton)`
  position: fixed;
  right: 3rem;
  bottom: 1rem;
  width: 4rem;
  height: 4rem;
  border-radius: 50%;
  padding: 0;
  z-index: 1301;
`;

// TODO: TFR-44 move to icon group
export const ChatBubbleIcon = styled(FiMessageCircle)`
  color: ${({ theme }) => theme.colors.white};
  font-size: 1.9rem;
`;
// @ts-ignore
export const Box = styled(DefaultBox)`
  background-color: ${({ theme }) => theme.colors.blueLight};
`;

export const NavLink = styled(NavLinkDefault)`
  padding: 0 0.25rem;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.greenExtraDark};
  &.selected {
    color: ${({ theme }) => theme.colors.greenExtraDark};
  }
`;

// TODO: TFR-46 remove imports in styled.ts if you do not add styles to component
export const Loader = styled(DefaultGlobalLoader)``;
